import React from 'react';
import { graphql } from 'react-apollo';
import { GET_LAYOUT_TYPE_BY_ID } from "../../../queries/layout_type";

const layoutType = (props) => {
  const layoutTypeById = props.data.layoutTypeById;
  if (props.data.loading) return <p>Loading...</p>;
  if (props.data.error) return <p>Error :(</p>;
  if(layoutTypeById)
    return (<>{ layoutTypeById.name }</>);
  else
    return (<>Layout Type not exists.</>)
}
export const LayoutTypesLookup = graphql(GET_LAYOUT_TYPE_BY_ID, {options: (props) =>({ variables: { id: props.layoutTypeId }})})(layoutType);